__turbopack_context__.v({
  "container": "BRNVZG_container",
});
